import { defineStore } from 'pinia'
import type { ObjectTreeItemType } from './types'
import { ref, watch } from 'vue'
import { useLoadTree } from './../model/api'
import { sortBy } from 'lodash'

export const useObjectTree = defineStore('object_tree', () => {
  const objects = ref<ObjectTreeItemType[]>([])
  const selectObjects = ref<ObjectTreeItemType[]>([])
  const selectObjectId = ref(0)
  const cutObjects = ref<ObjectTreeItemType[]>([])

  const contextObject = ref<ObjectTreeItemType | null>(null)
  const contextPosition = ref({ x: 0, y: 0 })

  const dragObjects = ref<ObjectTreeItemType[]>([])
  const pathObject = ref<number[]>([])

  /**
   * Функция получения корня дерева с сервера
   */
  const load = () => {
    const res = useLoadTree()

    res.refetch()
    watch(res.data, () => (objects.value = build(res.data.value?.data || [])))

    return res
  }

  /**
   * Функция получения потомков дерева с сервера
   * @param item
   */
  const loadChild = (item: ObjectTreeItemType) => {
    const res = useLoadTree(item.id)

    watch(res.data, () => (item.children = build(res.data.value?.data || [])))

    return res
  }

  /**
   * Функция построения дерева
   * @param data
   */
  const build = (data: any[]): ObjectTreeItemType[] => {
    return sortBy(data, 'name').map((item) => {
      return {
        ...item,
        is_active: true,
        is_error: false,
        children: [],
      }
    })
  }

  /**
   * Функция добавление элемента в выделенные
   * @param object
   */
  const addSelected = (object: ObjectTreeItemType) => {
    if (selectObjects.value.find((item) => item.id == object.id)) {
      selectObjects.value = selectObjects.value.filter((item) => item.id != object.id)
    } else {
      selectObjects.value.push(object)
    }
  }

  /**
   * Функция очистки выделенных элементов
   */
  const clearSelected = () => {
    selectObjects.value = []
  }

  return {
    objects,
    selectObjectId,
    selectObjects,
    cutObjects,
    contextObject,
    contextPosition,
    dragObjects,
    pathObject,

    load,
    loadChild,
    addSelected,
    clearSelected,
  }
})
